module.exports = __webpack_public_path__ + "media/images/noise-d96e95a4c28169b1c3178a78bb5ee201.png";